import React from 'react';
import _ListSocial from './_ListSocial.scss';

class ListSocialRight extends React.Component {

  render() {
    return (
      <div className="list-social"></div>
    );
  }
}
export default ListSocialRight;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/ListSocialRight.jsx